<div
  [class]="'card p-3 ' + outerClass"
  [ngClass]="{
    'box-shadow': boxShadow,
    disabled: disabled,
    'card-hover': cardHover,
    'highlight-card shadow': highlight
  }">
  <div [class]="'fh-card ' + innerClass">
    @if (title) {
      <ui-fh-text [text]="title" [type]="'CARD-TITLE'"></ui-fh-text>
    }
    @if (subtitle) {
      <ui-fh-text [text]="subtitle" [type]="'CARD-DESCRIPTION'"></ui-fh-text>
    }
    <ng-content></ng-content>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
